import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Code from './pages/Code'

import Login from './pages/Login'
import Register from './pages/Register'

import Avatar from './pages/Avatar'
import Sessions from './pages/Sessions'
import Session from './pages/Session'
import Ranking from './pages/Ranking'
import Rewards from './pages/Rewards'

/* activities*/
import Quiz from './pages/activities/Quiz'
import Video from './pages/activities/Video'

import Certificate from './pages/Certificate'
import Galery from './pages/Gallery'
import Chatgpt from './pages/Chatgpt'

import AdminLogin from './pages/admin/Login'
import Companies from './pages/admin/Companies'
import Students from './pages/admin/Students'
import Support from './pages/admin/Support'

import { AuthProvider } from './contexts/auth'
import { ThemeClient } from './contexts/Theme'
import { CodeProvider } from './contexts/Code'
import { CompanyProvider } from './contexts/Company'
//import { FirebaseProvider } from "./contexts/Notification";

import CreateOrUpdateCompany from "./pages/admin/CreateOrUpdateCompany";
import VirtualLibrary from "./pages/VirtualLibrary";
import VirtualLibraryMenu from "./pages/VirtualLibraryMenu";

import Library from './pages/admin/Library'
import Feedback from './pages/admin/Feedback'
import AdminMessages from './pages/admin/Messages'
import AdminRewards from './pages/admin/Rewards'

import Message from './pages/Messages'
import Calendar from "./pages/admin/Calendar";
import UpdatePassword from "./pages/update-password";

import ProtectedRoute from "./components/login/ProtectedRoute";

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <CodeProvider>
          <CompanyProvider>
          {/* <FirebaseProvider> */}
            <div>
              <ThemeClient>
              <Switch>
                  <ProtectedRoute exact path="/">
                    <Sessions/>  
                  </ProtectedRoute>
                  <Route exact path="/code">
                    <Code/>  
                  </Route>
                  <Route path="/update-password">
                    <UpdatePassword />
                  </Route>
                  <Route path="/login">
                    <Login />
                  </Route>
                  <Route path="/register">
                    <Register />
                  </Route>
                  <ProtectedRoute path="/avatar">
                    <Avatar />
                  </ProtectedRoute>
                  <ProtectedRoute path="/sessions/:id">
                    <Session />
                  </ProtectedRoute>
                  <ProtectedRoute path="/sessions">
                    <Sessions />
                  </ProtectedRoute>
                  <ProtectedRoute path="/ranking">
                    <Ranking />
                  </ProtectedRoute>
                  <ProtectedRoute path="/activities/video">
                    <Video />
                  </ProtectedRoute>
                  <ProtectedRoute path="/activities/quiz">
                    <Quiz />
                  </ProtectedRoute>
                  <ProtectedRoute path="/certificate">
                    <Certificate />
                  </ProtectedRoute>
                  <ProtectedRoute path="/gallery">
                    <Galery />
                  </ProtectedRoute>
                  <ProtectedRoute path="/chatgpt">
                    <Chatgpt />
                  </ProtectedRoute>
                  <ProtectedRoute path="/librarymenu">
                    <VirtualLibraryMenu />
                  </ProtectedRoute>
                  <ProtectedRoute path="/library">
                    <VirtualLibrary />
                  </ProtectedRoute>
                  <ProtectedRoute path="/messages">
                    <Message />
                  </ProtectedRoute>
                  <ProtectedRoute path="/rewards">
                    <Rewards />
                  </ProtectedRoute>
                  <Route path="/admin/login">
                    <AdminLogin />
                  </Route>
                  <Route path="/admin/calendar">
                    <Calendar />
                  </Route>
                  <Route path="/admin/companies/create">
                    <CreateOrUpdateCompany />
                  </Route>
                  <Route path="/admin/companies/:id/edit">
                    <CreateOrUpdateCompany />
                  </Route>
                  <Route path="/admin/companies">
                    <Companies />
                  </Route>
                  <Route path="/admin/students">
                    <Students />
                  </Route>
                  <Route path="/admin/support">
                    <Support />
                  </Route>
                  <Route path="/admin/library">
                    <Library />
                  </Route>
                  <Route path="/admin/feedback">
                    <Feedback />
                  </Route>
                  <Route path="/admin/messages">
                    <AdminMessages />
                  </Route>
                  <Route path="/admin/rewards">
                    <AdminRewards />
                  </Route>
                  <Route path="/admin">
                    <Companies />
                  </Route>
                  </Switch>
              </ThemeClient>
            </div>
            {/* </FirebaseProvider> */}
          </CompanyProvider>
        </CodeProvider>
      </AuthProvider>
    </Router >
  );
}